/**
 * @file index.js
 * @description Application entry point. Creates the React root and mounts the App
 *   component inside StrictMode to surface potential issues during development.
 * @author IEEE CIS UJ Web Team
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Mount the application onto the #root element defined in public/index.html.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Forward Core Web Vitals to an analytics endpoint when needed.
reportWebVitals();
